"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var QueryOutputType;
(function (QueryOutputType) {
    QueryOutputType["arrayOfObjects"] = "arrayOfObjects";
    QueryOutputType["arrayOfArrays"] = "arrayOfArrays";
})(QueryOutputType = exports.QueryOutputType || (exports.QueryOutputType = {}));
//# sourceMappingURL=QueryOutputType.js.map